import React, { useState } from 'react'



export default function Faq() {
    const [open, setOpen] = useState(null);
    const [openIndex, setOpenIndex] = useState(null);
    const faqData = [
        {
            id: "01",
            question: 'What is B4Salary, and how does the online loan process work ?',
            answer: 'B4Salary is a digital lending platform that helps salaried professionals explore digital borrowing options online. Users can complete the application, document upload, and verification process digitally through a structured and transparent journey. Loans are facilitated through our RBI-registered NBFC partner, Kisga Leasing and Finance Pvt Ltd.',
        },
        {
            id: "02",
            question: 'Who can apply for an instant personal loan through B4Salary ?',
            answer: 'Salaried professionals meeting the eligibility criteria may apply for an instant personal loan through B4Salary. Eligibility may depend on factors such as monthly income, employment profile, repayment capacity, verification status, and lender evaluation.',
        },
        {
            id: "03",
            question: 'How much loan amount can I apply for ?',
            answer: 'Eligible users may explore loan options starting from smaller short-term amounts up to higher loan amounts based on profile evaluation and lender policies. The final approved amount depends on eligibility, income verification, repayment history, and other assessment criteria.',
        },
        {
            id: "04",
            question: 'What documents are required for applying for a personal loan online ?',
            answer: 'Applicants are generally required to submit basic KYC and income-related documents during the digital verification process. This may include PAN card, Aadhaar card, bank details, salary proof, and other documents requested during evaluation.',
        },
        {
            id: "05",
            question: 'Do I need collateral or security for these loans ?',
            answer: 'No collateral or asset security is generally required for applying for unsecured personal loans through B4Salary. Eligibility is assessed based on profile verification, income details, repayment capacity, and lender evaluation criteria.',
        },
        {
            id: "06",
            question: 'How long does approval and loan disbursal usually take ?',
            answer: 'Application review timelines may vary depending on profile verification, document completeness, and lender evaluation. Once approved, the loan amount is disbursed directly to the registered bank account, subject to banking timelines and processing conditions.',
        }
       



    ];
    return (
        <>
            <div className='w-full p-4 py-10'>
                {/* <div className='max-w-7xl m-auto '>
                    <div className='max-w-3xl m-auto text-center'>
                        <h4 className='lg:text-3xl text-2xl font-semibold'>Frequently Asked Questions</h4>
                        <p className='pt-4 pb-15'>Find quick answers to common questions about our services and process.</p>

                    </div>

                    <div className='grid grid-cols-1 lg:grid-cols-5 gap-6 items-start'>
                        <div className='lg:col-span-2 flex justify-center'>
                            <img src={faqImg} alt='' className="w-full max-w-sm lg:max-w-full h-auto" />
                        </div>
                        <div className='lg:col-span-3'>
                            <div className="max-w-full lg:max-w-[95%] mx-auto">
                                {faqData.map((faq, index) => (
                                    <div key={index} className="border border-gray-300 rounded-md mb-4 overflow-hidden">
                                        <button
                                            onClick={() =>
                                                setOpenIndex(openIndex === index ? null : index)
                                            }
                                            className="w-full flex justify-between items-center 
                           p-4 sm:p-5 font-semibold 
                           bg-gray-100 hover:bg-gray-200 transition"
                                        >
                                            <span className="text-left text-sm sm:text-base">
                                                {faq.question}
                                            </span>
                                            <span className="text-xl">
                                                {openIndex === index ? "−" : "+"}
                                            </span>
                                        </button>

                                        {openIndex === index && (
                                            <div className="p-4 sm:p-5 text-gray-600 text-sm sm:text-base">
                                                {faq.answer}
                                            </div>
                                        )}
                                    </div>
                                ))}
                            </div>

                        </div>
                    </div>
                </div> */}

                {/* new faq  */}
                <section className="">
                    <div className="max-w-5xl mx-auto py-15 pb-5 px-7 ">
                        <h4 className="lg:text-3xl text-2xl lg:font-semibold text-center">
                            Frequently Asked <span>Questions</span>
                        </h4>
                        <p className='pt-4 pb-15 text-center'>Find answers to common questions about B4SALARY services</p>


                        {/* FAQ Item 1 */}
                        <div className="border border-orange-300 rounded-lg bg-white mb-4">
                            <button onClick={() => setOpen(open === 1 ? null : 1)}
                                className="w-full flex justify-between items-center px-6 py-4 text-left" >
                                <span className="font-medium text-gray-800 lg:text-lg"> What is a Non-Banking Financial Company (NBFC)? </span>
                                <span className={`transition-transform duration-300 ${open === 1 ? "rotate-45" : ""}`}> +  </span>
                            </button>

                            <div className={`overflow-hidden transition-all duration-300 ${open === 1 ? "px-6 pb-4" : "max-h-0"}`} >
                                <p className="text-gray-600 lg:text-base sm:text-sm">
                                    A Non-Banking Financial Company (NBFC) is a financial institution that provides various services such as loans, advances, leasing, hire-purchase, and insurance, but does not engage in activities such as agriculture, industrial operations, or the sale of goods or services. It is also a company registered under the Companies Act 1956 and is not allowed to accept deposits from the public. Additionally, NBFCs are also known as Residuary non-banking company. What are the differences between banks and NBFCs, as both perform similar functions such as lending and investing? </p>
                                    <ul className='py-3 gap-4'>
                                        <li> <span className='font-medium ms-text-secondary'>1-</span> NBFCs cannot accept demand deposits.</li>
                                        <li> <span className='font-medium ms-text-secondary'>2-</span> NBFCs do not form part of the payment and settlement system and cannot issue cheques drawn on themselves.</li>
                                        <li> <span className='font-medium ms-text-secondary'>3-</span> The deposit insurance facility of Deposit Insurance and Credit Guarantee Corporation is not available to depositors of NBFCs, unlike in the case of banks.</li>
                                    </ul>

                            </div>
                        </div>

                        {/* FAQ Item 2 */}
                        <div className="border border-orange-300 rounded-lg bg-white mb-4">
                            <button onClick={() => setOpen(open === 2 ? null : 2)}
                                className="w-full flex justify-between items-center px-6 py-4 text-left" >
                                <span className="font-medium text-gray-800 lg:text-lg">   What is B4SALARY and how does it work? </span>
                                <span className={`transition-transform duration-300 ${open === 2 ? "rotate-45" : ""}`} >  + </span>
                            </button>

                            <div className={`overflow-hidden transition-all duration-300 ${open === 2 ? "px-6 pb-4" : "max-h-0"}`}>
                                <p className="text-gray-600 lg:text-base sm:text-sm">
                                    B4SALARY is a financial technology solution from Kisga Leasing and Finance Pvt Ltd. that enables young salaried individuals to access short-term personal loans using a convenient app. The process is streamlined and requires minimal paperwork, with only a salary slip, bank statement, PAN card, and proof of address needed to be uploaded through the app. The loan disbursal is quick, with the money being transferred to the borrower's bank account in a matter of minutes.
                                </p>
                                

                            </div>
                        </div>

                        {/* FAQ Item 3 */}
                        <div className="border border-orange-300 rounded-lg bg-white mb-4">
                            <button onClick={() => setOpen(open === 3 ? null : 3)}
                                className="w-full flex justify-between items-center px-6 py-4 text-left">
                                <span className="font-medium text-gray-800 lg:text-lg">  Who can apply for a loan with B4SALARY ? </span>
                                <span className={`transition-transform duration-300 ${open === 3 ? "rotate-45" : ""}`}>  + </span>
                            </button>

                            <div className={`overflow-hidden transition-all duration-300 ${open === 3 ? "max-h-40 px-6 pb-4" : "max-h-0"}`}>
                                <p className="text-gray-600"> It is important to note that the requirement for a personal loan can vary based on the lender and the type of loan. The requirements you have mentioned are specific to B4SALARY , and may not apply to other lenders. It's always advisable to check with the lender directly or visit their website to confirm the specific requirements for a personal loan with them.</p>
                            </div>
                        </div>

                        {/* FAQ Item 4 */}
                        <div className="border border-orange-300 rounded-lg bg-white mb-4">
                            <button onClick={() => setOpen(open === 4 ? null : 4)}
                                className="w-full flex justify-between items-center px-6 py-4 text-left" >
                                <span className="font-medium text-gray-800 lg:text-lg"> How much can I borrow from B4SALARY ? </span>
                                <span className={`transition-transform duration-300 ${open === 4 ? "rotate-45" : ""}`} >  + </span>
                            </button>

                            <div className={`overflow-hidden transition-all duration-300 ${open === 4 ? "px-6 pb-4" : "max-h-0"}`}>
                                <p className="text-gray-600">
                                    It's important to note that the loan amount you can borrow and the repayment period can vary based on the lender and the type of loan. The information you have mentioned is specific to B4SALARY , and may not apply to other lenders. It's always advisable to check with the lender directly or visit their website to confirm the specific loan amount and repayment period for a personal loan with them. It's also worth noting that the loan amount you qualify for will depend on your creditworthiness, income and debt-to-income ratio, and other factors considered by the lender.
                                </p>

                            </div>
                        </div>

                        {/* FAQ Item 5 */}
                        <div className="border border-orange-300 rounded-lg bg-white mb-4">
                            <button onClick={() => setOpen(open === 5 ? null : 5)}
                                className="w-full flex justify-between items-center px-6 py-4 text-left" >
                                <span className="font-medium text-gray-800 lg:text-lg"> What documents are required for applying for a Personal Loan from B4SALARY? </span>
                                <span className={`transition-transform duration-300 ${open === 5 ? "rotate-45" : ""}`} >  + </span>
                            </button>

                            <div className={`overflow-hidden transition-all duration-300 ${open === 5 ? "px-6 pb-4" : "max-h-0"}`}>
                                <p className="font-medium pb-3"> Here's the list of documents that are typically required for a personal loan application from B4SALARY:
Here's the list of documents that are typically required for a personal loan application from B4SALARY: </p>

                                <ul className='text-sm leading-8'>
                                    <li>Photo Identity Proof: PAN card</li>
                                    <li>Latest salary slip</li>
                                    <li>Aadhaar Card</li>
                                    <li>Permanent Address Proof: Any one of the following: Passport, Driving License, Voter's Identity Card or Utility Bills (e.g. Electric/landline phone bill/Gas Bill) that are not more than 2 months old.</li>
                                    <li> If the current address is different from the permanent address, then additionally: Utility Bill (e.g. Electric/landline phone bill/Gas Bill) of current address that is not more than 2 months old, Leave & License Agreement/Rent Agreement</li>
                                    <li> Latest statement of your Bank Account, showing your salary credit</li>
                                </ul>

                            </div>
                        </div>

                         {/* FAQ Item 6 */}
                        <div className="border border-orange-300 rounded-lg bg-white mb-4">
                            <button onClick={() => setOpen(open === 6 ? null : 6)}
                                className="w-full flex justify-between items-center px-6 py-4 text-left" >
                                <span className="font-medium text-gray-800 lg:text-lg"> Do we need any collateral/security? </span>
                                <span className={`transition-transform duration-300 ${open === 6 ? "rotate-45" : ""}`} >  + </span>
                            </button>

                            <div className={`overflow-hidden transition-all duration-300 ${open === 6 ? "px-6 pb-4" : "max-h-0"}`}>
                                <p className="text-gray-600"> Clearly NO, we believe in our customers and have trust in them. Therefore, we do not require any collateral or security to be provided when applying for a personal loan. All we need are your valid documents to verify your eligibility. </p>
                            </div>
                        </div>


                    </div>
                </section>

               
                {/* end */}

            </div>
        </>
    )
}
